
export enum DirectionEnum {
  North = 'North',
  East = 'East',
  South = 'South',
  West = 'West',
}
